export default function ContactDetails() {
  const contactInfo = [
    {
      icon: 'phone',
      label: 'Call Us',
      value: '(347) 724-1199',
      link: 'tel:+13477241199'
    },
    {
      icon: 'mail',
      label: 'Email Us',
      value: 'service@independencemedical.com',
      link: 'mailto:service@independencemedical.com'
    },
    {
      icon: 'time',
      label: 'Business Hours',
      value: 'Mon-Fri: 8AM-6PM, Sat: 9AM-3PM',
      link: null
    }
  ];

  return (
    <section className="py-16 bg-[#1e3a5f]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {contactInfo.map((info, index) => (
            <div key={index}>
              {info.link ? (
                <a
                  href={info.link}
                  className="flex flex-col items-center text-center p-6 rounded-lg hover:bg-[#14B8A6]/10 transition-colors cursor-pointer group"
                >
                  <div className="w-16 h-16 flex items-center justify-center mb-4">
                    <i className={`ri-${info.icon}-line text-white text-5xl group-hover:text-[#14B8A6] transition-colors`}></i>
                  </div>
                  <p className="text-white/80 text-sm font-medium mb-2">
                    {info.label}
                  </p>
                  <p className="text-white text-lg font-bold">
                    {info.value}
                  </p>
                </a>
              ) : (
                <div className="flex flex-col items-center text-center p-6">
                  <div className="w-16 h-16 flex items-center justify-center mb-4">
                    <i className={`ri-${info.icon}-line text-white text-5xl`}></i>
                  </div>
                  <p className="text-white/80 text-sm font-medium mb-2">
                    {info.label}
                  </p>
                  <p className="text-white text-lg font-bold">
                    {info.value}
                  </p>
                </div>
              )}
              {index < contactInfo.length - 1 && (
                <div className="hidden md:block absolute right-0 top-1/2 transform -translate-y-1/2 w-px h-16 bg-white/20"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}